import { RedoAction, UndoAction } from "../actions/undo";
import { store } from "../store";

const initialState = {
	lastAction: null,
	canUndo: false,
	canRedo: false,
	undo() {
		store.dispatch(new UndoAction());
	},
	redo() {
		store.dispatch(new RedoAction());
	}
};

/**
 * Reducer managing undo/redo history.
 *
 * @name UndoReducer
 *
 * @param {Object} state - Current application state
 * @param {AbstractAction} action - Action to dispatch
 * @return {Object} new state
 */
export default (state = initialState, action) => {
	if (!action.isAction) {
		// TODO: remove when we use new style action everywhere
		return state;
	}

	return action.performUndoReducer(state);
};
